import { Trans } from '@lingui/react/macro';
import { Box, Button, Loader, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useGetLinks } from 'shared/domains/urls';
import { getLockedReasonMessage } from './utils';
import { OptionContainer, ReasonContainer } from './styled';
export function DownloadOption(props) {
    const { type, title, downloading, lockedReason, pleditorDownloadUnavailable, onDownload } = props;
    const { contact } = useGetLinks();
    const disabled = pleditorDownloadUnavailable || lockedReason !== undefined;
    return (<OptionContainer>
      <Box flexDirection="column" width="100%">
        <Box alignItems="center" justifyContent="space-between" p="md" gap="2xl">
          <Box alignItems="center" gap="md">
            {type === 'pdf' ? (<Falcon $color="gray.700" icon="file-pdf"/>) : (<Falcon $color="gray.700" icon="file-word"/>)}

            <Typography $fontSize="medium" $appearance="300" $fontWeight="medium">
              {title}
            </Typography>
          </Box>

          <Button size="xs" appearance={disabled ? 'secondary' : 'primary'} disabled={disabled || downloading} onClick={onDownload}>
            {downloading && <Loader />}
            <Trans comment="Download document label">Download</Trans>
          </Button>
        </Box>

        {disabled && (<ReasonContainer>
            <Typography $fontSize="small" $appearance="300" $fontWeight="semibold">
              <Trans comment="Download document dialog - Download unavailable title">DOCX download unavailable</Trans>
            </Typography>

            <Typography $fontSize="small" $appearance="200">
              {pleditorDownloadUnavailable && (<Trans comment="Download document dialog - Download unavailable - Pleditor import/export not available">
                  Downloading as a DOCX file is not available on your current plan (paid feature). To enable this,
                  please contact support. Note that you can still download te document as PDF.
                </Trans>)}

              {lockedReason && getLockedReasonMessage(lockedReason)}
            </Typography>

            {pleditorDownloadUnavailable && (<Button as="a" appearance="secondary" size="xs" href={contact} target="_blank" rel="noopener noreferrer">
                <Trans context="Download document dialog" comment="Download unavailable - Pleditor import/export not available - Button label">
                  Contact support
                </Trans>
              </Button>)}
          </ReasonContainer>)}
      </Box>
    </OptionContainer>);
}
